var map = {
	"./common_group/view_file/index": "SYCz",
	"./customers_group/customer_summary/index": "On7K",
	"./estimates_group/customer_component/index": "PS6s",
	"./estimates_group/customer_summary_field/index": "eZ8i",
	"./estimates_group/data_component/_parts/coupon/index": "2m1H",
	"./estimates_group/data_component/_parts/custom_price/index": "MOjv",
	"./estimates_group/data_component/_parts/custom_product_block/index": "9v8c",
	"./estimates_group/data_component/_parts/options_block/index": "pGgr",
	"./estimates_group/data_component/_parts/product_block/index": "SdLk",
	"./estimates_group/data_component/_parts/qty_selector_block/index": "vIpy",
	"./estimates_group/data_component/_parts/shipping_block/index": "/PQT",
	"./estimates_group/data_component/_parts/ticket/index": "LpHJ",
	"./estimates_group/data_component/index": "rWbK",
	"./header_group/logo/index": "RIXV",
	"./modeling_group/custom_svg_instance_editor/index": "rnkm",
	"./modeling_group/custom_svg_template_editor/index": "wWUB",
	"./modeling_group/customized_svg_parser/index": "6g+G",
	"./modeling_group/impose_model_editor/index": "ocvX",
	"./modeling_group/pregistration_svg_field_value/index": "v3sG",
	"./modeling_group/printing_registration_editor/index": "kCf9",
	"./modeling_group/svg_instance_editor/index": "dOFb",
	"./modeling_group/template_manager/index": "2iNx",
	"./my_profile_group/dashboard/index": "DcPG",
	"./orders_group/change_status_component/index": "PVCA",
	"./orders_group/details/index": "2bj9",
	"./orders_group/edit_texts_component/index": "pIjF",
	"./orders_group/orders_counter/index": "lV3M",
	"./orders_group/preview_component/index": "nDs/",
	"./orders_group/total_turnover/index": "fyfp",
	"./orders_group/upload_payment_proof_component/index": "vUMe",
	"./products_group/index": "SL/L",
	"./shop_management/sample_configuration/index": "avWV",
	"./test_env/index": "ncbM"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1y7c";